import type { CheckboxPassThroughOptions } from 'primevue';
import { PassThrough } from '@primevue/core';

export enum CheckboxSize {
  SMALL = 'small',
  BIG = 'big',
}

export type PassThroughMeridiaCheckbox =
  PassThrough<CheckboxPassThroughOptions> & {
    label?: { class: string };
    wrapper?: { class: string };
  };
